import React from 'react';
import { ComingSoon } from '@components';

const MusicPage = () => <ComingSoon subdomain="music" />;

export default MusicPage;
